<template>

	<v-content>
		<v-container fluid  class="p-0">
			<div style="width:100%">
				<v-tabs color="dark" slider-color="white" dark grow fixed-tabs>

					<v-tab>ÇİZELGE</v-tab>
					<v-tab>Markalar</v-tab>
					<v-tab>Raporlar</v-tab>
					<v-tab>ARŞİV</v-tab>

					<v-tab-item >
						<SocialmediaCronWorksList /> 
					</v-tab-item>

					<v-tab-item >
						<SocialmediaCronBrandsList /> 
					</v-tab-item>

					<v-tab-item >
						<SocialmediaCronReportsList /> 
					</v-tab-item>

					<v-tab-item >
						<SocialmediaCronArchiveList /> 
					</v-tab-item>

				</v-tabs>
			</div>
		</v-container>
	</v-content>


</template>


<script>

	import SocialmediaCronWorksList from "@/includes/Socialmedia/Cron/Works/List"
	import SocialmediaCronBrandsList from "@/includes/Socialmedia/Cron/Brands/List"
	import SocialmediaCronReportsList from "@/includes/Socialmedia/Cron/Reports/List"
	import SocialmediaCronArchiveList from "@/includes/Socialmedia/Cron/Archive/List"

	export default {
		name : "SocialmediaCron",
		components : {
			SocialmediaCronWorksList,
			SocialmediaCronBrandsList,
			SocialmediaCronReportsList,
			SocialmediaCronArchiveList,
		},
		data : () => ({
			tabs: {
				tabTitles: [
					{title : "Çizelge"},
					{title : "Markalar"},
					{title : "Raporlar"}
				]
			}
		})
	}
</script>

<style lang="less">
	.p-0{
		padding : 0px;
	}
</style>
